function Star() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      fill="currentColor"
    >
      <path d="M24 4l6.92 14.04L46 19.27l-11 10.73 2.6 15.2L24 37.77l-13.6 7.43L13 30 2 19.27l15.08-1.23L24 4z" />
    </svg>
  );
}

export default Star;
